
import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
import CustomCarousel from './CustomCarousel';
import Gallery from './Smallimages';
import './smallkey.css';
import { Helmet } from 'react-helmet';

function Picninspotneargadchiroli() {



  const cardData =
  {
    keyword: ' Picnic Spot Near Gadchiroli',
    heading:  'Woodland Escape: Picnic Spot Near Gadchiroli ',
    headingDescription: 'Woodland Escape Resort, situated just a short drive from Gadchiroli, makes an excellent picnic spot near Gadchiroli, combining serene natural surroundings with many amenities for families and friends. With open green lawns, shaded tree clusters, and forest-fringed picnic zones, visitors can lay out picnic spreads, play outdoor games, or take gentle nature walks to refresh their minds. The resort’s comfortable facilities, home-style meals, and relaxed atmosphere add to the ease of a day-out, allowing groups and families to enjoy quality time away from city stress. Perfect for sunrise meet-ups or relaxed afternoon outings, Woodland Escape Resort near Gadchiroli delivers a memorable picnic experience in nature’s embrace.',

    top: 'Top Activities of Woodland Escape Resort Near Nagpur',
   "topPlaces": [
  {
    "title": "Forest Retreat Stay Experience",
    "description": "Woodland Escape Resort offers a serene getaway surrounded by dense forests, misty hills, and soothing sounds of nature. Guests wake up to the melodies of chirping birds and the cool fragrance of dewy mornings. The resort blends rustic charm with modern elegance, creating an ambiance of true peace and comfort. Every corner reflects nature’s simplicity, encouraging travelers to disconnect from the city rush. Whether you’re lounging on the porch with a cup of tea or strolling through the green pathways, the stay promises calmness and clarity. It’s a retreat where you can breathe freely, unwind deeply, and reconnect with your natural rhythm."
  },
  {
    "title": "Luxury Cottages Amid Nature",
    "description": "The resort’s cottages are thoughtfully crafted to provide an authentic forest-luxury experience. Each cottage is built using eco-friendly materials and designed to offer panoramic views of the surrounding woods. Inside, guests enjoy spacious interiors, cozy bedding, and all modern amenities while staying close to nature’s essence. The gentle hum of the forest replaces city noise, offering a deeply restful environment. From sunrise reflections on your balcony to starry skies at night, every moment here feels timeless. Families, couples, and solo travelers alike find these cottages perfect for soulful relaxation amidst nature’s raw beauty."
  },
  {
    "title": "Wildlife and Tiger Safari",
    "description": "Adventure seekers can experience the thrill of the wild through guided tiger safaris organized near the resort. The region’s dense forests are home to majestic tigers, deer, peacocks, and countless species of birds. Expert naturalists accompany visitors, ensuring a safe and educational journey through the jungle. Each safari offers an adrenaline rush mixed with awe as you witness the raw beauty of wildlife in its natural habitat. The early morning and evening safaris are especially magical, when golden sunlight filters through the trees and animals emerge from their hiding places. It’s an unforgettable adventure that connects you to the untamed heart of nature."
  },
  {
    "title": "Nature Trails and Jungle Walks",
    "description": "For those who prefer calm exploration, Woodland Escape Resort’s nature trails offer the perfect adventure. Meandering paths take guests through wildflowers, bamboo groves, and hidden forest streams. Every step reveals something new — a bird call, a butterfly dance, or the gentle rustle of leaves. Guided jungle walks help you learn about the region’s biodiversity and plant life. It’s not just a walk; it’s an immersion into a living ecosystem that refreshes the mind and body. The experience is ideal for photographers, nature lovers, and families who want to reconnect with the wonders of the natural world."
  },
  {
    "title": "Campfire and Barbecue Nights",
    "description": "As dusk settles over the forest, Woodland Escape Resort transforms into a magical open-air lounge. Guests gather around the crackling bonfire, sharing laughter and stories under a canopy of stars. The aroma of freshly grilled barbecue fills the air, accompanied by light music and soft forest winds. Whether you’re roasting marshmallows with family or joining a live music night, the warmth of the fire unites everyone in celebration. This nightly ritual captures the essence of togetherness — blending fun, relaxation, and nature’s comfort into one unforgettable evening experience."
  },
  {
    "title": "Adventure and Outdoor Games",
    "description": "Beyond peaceful moments, the resort also offers a range of exciting outdoor adventures. Guests can try their hands at archery, cycling through forest trails, or rope-climbing challenges. A well-equipped outdoor arena allows for group sports like volleyball, cricket, and badminton. For thrill-seekers, there are guided treks and obstacle courses designed for team-building. Each activity encourages bonding, laughter, and energy in the fresh, open air. Whether you’re a corporate group or a family on vacation, the balance of fun and fitness ensures every guest finds their own rhythm of adventure."
  },
  {
    "title": "Farm-to-Table Dining Experience",
    "description": "Dining at Woodland Escape Resort is a celebration of freshness and local flavor. The restaurant follows a true farm-to-table concept, using ingredients sourced from nearby farms and organic gardens. Traditional Maharashtrian and regional delicacies are prepared with authentic recipes and served in an inviting outdoor dining area. Every meal tells a story — of farmers, tradition, and sustainability. The aroma of home-cooked food mingles with the crisp forest air, creating a soulful dining experience. Guests can even participate in small cooking sessions or farm tours to see where their food comes from."
  },
  {
    "title": "Peaceful Meditation and Yoga Zone",
    "description": "For those seeking inner peace, the resort’s meditation and yoga zone offers the perfect sanctuary. Set amidst greenery and birdsong, this space allows guests to practice mindfulness in complete harmony with nature. Morning yoga sessions at sunrise and guided evening meditations under the open sky restore balance and positivity. The calm surroundings, fresh oxygen, and gentle breezes make every breath rejuvenating. Many guests describe it as a spiritual escape where body, mind, and soul realign. Whether you’re an experienced yogi or a beginner, this serene corner helps you rediscover your inner calm."
  }
],



"services": [
    {
      "name": "Picnic Spot Near Gadchiroli",
      "description": "Discover the best picnic spots near Gadchiroli offering lush greenery, tranquil surroundings, and recreational activities. Perfect for families and friends looking to enjoy a refreshing day outdoors away from the city."
    },
    {
      "name": "Gadchiroli Top Picnic Places",
      "description": "Explore the top picnic destinations in Gadchiroli featuring scenic landscapes, well-maintained gardens, riversides, and hill views. Ideal for photography, relaxation, and memorable outings."
    },
    {
      "name": "Gadchiroli Family Picnic Spot",
      "description": "Plan a family picnic in Gadchiroli with kid-friendly amenities, open spaces, and fun activities ensuring an enjoyable experience for people of all ages."
    },
    {
      "name": "Gadchiroli Nature Picnic Spot",
      "description": "Reconnect with nature at Gadchiroli’s serene picnic locations surrounded by forests, rivers, and hills. Perfect for nature walks, birdwatching, and peaceful outdoor relaxation."
    },
    {
      "name": "Affordable Picnic Spot Gadchiroli",
      "description": "Enjoy budget-friendly picnic spots in Gadchiroli that provide great amenities, scenic surroundings, and recreational activities without stretching your budget."
    },
    {
      "name": "Gadchiroli Weekend Picnic",
      "description": "Spend a refreshing weekend at Gadchiroli’s picnic spots, ideal for short trips with family or friends to unwind from city life and enjoy the beauty of nature."
    },
    {
      "name": "Gadchiroli Riverside Picnic Spot",
      "description": "Relax by the riverside at Gadchiroli’s picnic locations offering calm water views, picnic tables, and opportunities for water-based activities and photography."
    },
    {
      "name": "Gadchiroli Garden Picnic Spot",
      "description": "Visit beautifully maintained garden picnic spots in Gadchiroli with flowering landscapes, seating areas, and open lawns perfect for a leisurely day out."
    },
    {
      "name": "Gadchiroli Hill Picnic Spot",
      "description": "Enjoy panoramic hill views and cool breezes at Gadchiroli’s hilltop picnic spots, ideal for trekking, nature walks, and serene getaways."
    },
    {
      "name": "Gadchiroli Kids Friendly Picnic Spot",
      "description": "Take your children to safe and entertaining picnic locations in Gadchiroli with play areas, greenery, and activities designed for young ones."
    },
    {
      "name": "Gadchiroli Scenic Picnic Spot",
      "description": "Capture stunning landscapes and enjoy breathtaking scenery at Gadchiroli’s picnic destinations, perfect for photography, relaxation, and peaceful outdoor experiences."
    },
    {
      "name": "Gadchiroli Outdoor Picnic Spot",
      "description": "Experience open-air recreation at Gadchiroli’s outdoor picnic spots with ample space for games, barbecues, and group activities in a natural setting."
    },
    {
      "name": "Gadchiroli Picnic Spot Booking",
      "description": "Book your preferred picnic spot in Gadchiroli in advance to ensure a hassle-free outing with guaranteed amenities and facilities for a perfect day out."
    },
    {
      "name": "Gadchiroli Picnic Tour Packages",
      "description": "Explore curated picnic tour packages in Gadchiroli that include transport, meals, and guided activities for a complete day-out experience with family or friends."
    },
    {
      "name": "Gadchiroli Best Picnic Location",
      "description": "Plan your picnic at the best locations in Gadchiroli combining scenic beauty, relaxation, and fun activities to create a memorable outing."
    }
  ],
  "tableData": [
    ["- Picnic Spot Near Gadchiroli", "- Gadchiroli Top Picnic Places"],
    ["- Gadchiroli Family Picnic Spot", "- Gadchiroli Nature Picnic Spot"],
    ["- Affordable Picnic Spot Gadchiroli", "- Gadchiroli Weekend Picnic"],
    ["- Gadchiroli Riverside Picnic Spot", "- Gadchiroli Garden Picnic Spot"],
    ["- Gadchiroli Hill Picnic Spot", "- Gadchiroli Kids Friendly Picnic Spot"],
    ["- Gadchiroli Scenic Picnic Spot", "- Gadchiroli Outdoor Picnic Spot"],
    ["- Gadchiroli Picnic Spot Booking", "- Gadchiroli Picnic Tour Packages"],
    ["- Gadchiroli Best Picnic Location", ""]
  ],
  


whychoose: [
  {
    "WhyChooseheading": "Perfect Picnic Spot Near Gadchiroli",
    "WhyChoosedescription": "Woodland Escape Resort is a beautiful and peaceful picnic destination near Gadchiroli. Surrounded by nature and greenery, it’s the perfect place to relax, have fun, and spend a joyful day with your loved ones."
  },
  {
    "WhyChooseheading": "Peaceful Natural Environment",
    "WhyChoosedescription": "The resort is nestled amidst lush forests and open landscapes, offering a calm and refreshing atmosphere. Enjoy the beauty of nature while escaping the noise and rush of city life."
  },
  {
    "WhyChooseheading": "Ideal for Family and Group Picnics",
    "WhyChoosedescription": "Whether you’re planning a family get-together, a friends’ picnic, or a small group outing, Woodland Escape Resort provides a safe and spacious setting for fun games, bonding, and relaxation."
  },
  {
    "WhyChooseheading": "Fun and Leisure Activities",
    "WhyChoosedescription": "From cycling and nature walks to light outdoor games and pond-side relaxation, the resort offers plenty of enjoyable activities for visitors of all ages."
  },
  {
    "WhyChooseheading": "Comfortable Picnic Facilities",
    "WhyChoosedescription": "Enjoy shaded sit-outs, clean rest zones, and well-maintained picnic areas designed for your comfort. The resort ensures a convenient and memorable outdoor experience for everyone."
  },
  {
    "WhyChooseheading": "Delicious Food and Refreshments",
    "WhyChoosedescription": "Savor freshly prepared local dishes, snacks, and beverages during your picnic. The resort offers tasty food options to make your day even more enjoyable."
  },
  {
    "WhyChooseheading": "Easily Accessible from Gadchiroli",
    "WhyChoosedescription": "Located just a short drive from Gadchiroli, Woodland Escape Resort is the ideal spot for a quick and refreshing day out, letting you spend more time in nature and less time traveling."
  }
]




















  
  



  }

const faqData = [
  {
    question: "Why choose Woodland Escape Resort as a picnic spot near Gadchiroli?",
    answer: "Woodland Escape Resort is one of the most peaceful and refreshing picnic spots near Gadchiroli. Surrounded by natural greenery, it offers a calm environment where families and friends can unwind, play, and enjoy a day close to nature."
  },
  {
    question: "How far is Woodland Escape Resort from Gadchiroli city?",
    answer: "The resort is conveniently located within driving distance from Gadchiroli, making it ideal for a quick day trip or weekend outing. It’s easy to reach and perfect for those seeking a relaxing break from city life."
  },
  {
    question: "What activities are available for picnic visitors at Woodland Escape Resort?",
    answer: "Visitors can enjoy open lawns, outdoor games, nature walks, cycling, and scenic sitting areas. The resort offers a perfect mix of recreation and relaxation for both kids and adults."
  },
  {
    question: "Is Woodland Escape Resort suitable for families and groups visiting for a picnic?",
    answer: "Yes, Woodland Escape Resort is completely family-friendly and group-friendly. With safe, clean surroundings and spacious outdoor areas, it’s perfect for family picnics, school trips, and group outings."
  },
  {
    question: "Does Woodland Escape Resort provide food and refreshments for picnic guests?",
    answer: "Yes! The resort serves freshly prepared meals, snacks, and beverages. Picnic packages can include lunch and refreshments so guests can enjoy their day without any hassle."
  },
  {
    question: "How can we book a picnic at Woodland Escape Resort near Gadchiroli?",
    answer: "You can easily book your picnic by calling or sending a WhatsApp message to our reservations team, or by visiting our official website. Advance booking is recommended for weekends and holidays."
  }
];

const testimonials = [
  {
    name: "Mr. Santosh & Family, Gadchiroli",
    text: "Our picnic at Woodland Escape Resort was amazing! The greenery, open lawns, and peaceful vibe made it a perfect day out near Gadchiroli. The food was delicious too!"
  },
  {
    name: "Miss. Kavita & Friends, Gadchiroli",
    text: "We had a wonderful picnic experience at Woodland Escape Resort. The environment is calm, the staff is friendly, and there’s so much space to relax. Truly one of the best picnic spots near Gadchiroli!"
  }
];























      






  const carouselItems = testimonials.map(testimonial => (
    <div key={testimonial.name}>
      <blockquote>

        <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
        <footer className=' user'>— {testimonial.name}</footer>
      </blockquote>
    </div>
  ));

  const carouselOptions = {
    loop: true,
    margin: 10,
    nav: true,
    items: 1
  };

  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 9175577266",

    ],
    email: "woodlandescape01@gmail.com"
  };


  const Images = [
  { place: "/images/keyword/1.jpg", text: "1 day tour near Nagpur", link: "1-day-tour-near-Nagpur" },
  { place: "/images/keyword/2.jpg", text: "Best picnic spot near Nagpur", link: "best-picnic-spot-near-Nagpur" },
  { place: "/images/keyword/3.jpg", text: "Family picnic spot near Nagpur", link: "family-picnic-spot-near-Nagpur" },
  { place: "/images/keyword/4.jpg", text: "Nearest picnic spot in Nagpur", link: "nearest-picnic-spot-in-Nagpur" },
  { place: "/images/keyword/5.jpg", text: "Destination wedding spots near Nagpur", link: "destination-wedding-spots-near-Nagpur" },
  { place: "/images/keyword/6.jpg", text: "Pre wedding destination near Nagpur", link: "pre-wedding-destination-near-Nagpur" },
  { place: "/images/keyword/7.jpg", text: "One day adventure resorts near Nagpur", link: "one-day-adventure-resorts-near-Nagpur" },
  { place: "/images/keyword/8.jpg", text: "Activities resort near Nagpur", link: "activities-resort-near-Nagpur" },
  { place: "/images/keyword/9.jpg", text: "Best picnic spot near Akola", link: "best-picnic-spot-near-Akola" },
  { place: "/images/keyword/10.jpg", text: "One day tour near Akola", link: "one-day-tour-near-Akola" },
  { place: "/images/keyword/11.jpg", text: "Resorts near Akola for family", link: "resorts-near-Akola-for-family" },
  { place: "/images/keyword/12.jpg", text: "Destination wedding resorts near Akola", link: "destination-wedding-resorts-near-Akola" },
  { place: "/images/keyword/13.jpg", text: "Best picnic spot near Amravati", link: "best-picnic-spot-near-Amravati" },
  { place: "/images/keyword/14.jpg", text: "One day tour near Amravati", link: "one-day-tour-near-Amravati" },
  { place: "/images/keyword/15.jpg", text: "Family resorts near Amravati", link: "family-resorts-near-Amravati" },
  { place: "/images/keyword/16.jpg", text: "Pre-wedding location near Amravati", link: "pre-wedding-location-near-Amravati" },
  { place: "/images/keyword/17.jpg", text: "Picnic spot near Bhandara", link: "picnic-spot-near-Bhandara" },
  { place: "/images/keyword/18.jpg", text: "One day trip near Bhandara", link: "one-day-trip-near-Bhandara" },
//   { place: "/images/keyword/19.jpg", text: "Resorts near Bhandara for family outing", link: "resorts-near-Bhandara-for-family-outing" },
//   { place: "/images/keyword/20.jpg", text: "Destination wedding place near Bhandara", link: "destination-wedding-place-near-Bhandara" },
//   { place: "/images/keyword/21.jpg", text: "Best picnic spot near Buldhana", link: "best-picnic-spot-near-Buldhana" },
//   { place: "/images/keyword/22.jpg", text: "One day tour near Buldhana", link: "one-day-tour-near-Buldhana" },
//   { place: "/images/keyword/23.jpg", text: "Family resorts near Buldhana", link: "family-resorts-near-Buldhana" },
//   { place: "/images/keyword/24.jpg", text: "Wedding destination near Buldhana", link: "wedding-destination-near-Buldhana" },
//   { place: "/images/keyword/25.jpg", text: "Picnic spot near Chandrapur", link: "picnic-spot-near-Chandrapur" },
];



  const images = [
    { src: "/images/galleryy/3.jpg", alt: "Image 1" },
    { src: "/images/galleryy/2.jpg", alt: "Image 1" },
    { src: "/images/galleryy/3.jpg", alt: "Image 1" },
    { src: "/images/galleryy/4.jpg", alt: "Image 1" },
    { src: "/images/galleryy/5.jpg", alt: "Image 1" },
    { src: "/images/galleryy/6.jpg", alt: "Image 1" },
    { src: "/images/galleryy/7.jpg", alt: "Image 1" },
    { src: "/images/galleryy/8.jpg", alt: "Image 1" },
    { src: "/images/galleryy/9.jpg", alt: "Image 1" },
  ];

const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Picnic Spot Near Gadchiroli",
  "image": "https://woodlandescape.com/assets/images/picnic-gadchiroli.jpg",
  "description": "Visit Woodlandescape Resort, the ideal picnic spot near Gadchiroli. Enjoy family-friendly areas, scenic nature views, riverside and hill settings, outdoor activities, and affordable picnic packages.",
  "brand": {
    "@type": "Brand",
    "name": "Woodlandescape Resort"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "94"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1299",
    "availability": "https://schema.org/InStock",
    "url": "https://woodlandescape.com/picnic-spot-gadchiroli"
  }
};





  return (
    <div>
<Helmet>
  <title>Picnic Spot Near Gadchiroli | Family-Friendly & Scenic | Woodlandescape Resort</title>
  <meta 
    name="description" 
    content="Enjoy a perfect picnic at Woodlandescape Resort, a top picnic spot near Gadchiroli. Scenic nature views, riverside and hill areas, family-friendly spaces, and affordable picnic packages await you." 
  />
  <meta 
    name="keywords" 
    content="Picnic Spot Near Gadchiroli, Gadchiroli Top Picnic Places, Gadchiroli Family Picnic Spot, Gadchiroli Nature Picnic Spot, Affordable Picnic Spot Gadchiroli, Gadchiroli Weekend Picnic, Gadchiroli Riverside Picnic Spot, Gadchiroli Garden Picnic Spot, Gadchiroli Hill Picnic Spot, Gadchiroli Kids Friendly Picnic Spot, Gadchiroli Scenic Picnic Spot, Gadchiroli Outdoor Picnic Spot, Gadchiroli Picnic Spot Booking, Gadchiroli Picnic Tour Packages, Gadchiroli Best Picnic Location" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
   <section
  className="page-title"
  style={{
    backgroundImage: `
      linear-gradient(
        rgba(0, 0, 0, 0.6),
        rgba(0, 0, 0, 0.6)
      ),
      url(/images/page-title.jpg)
    `,
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
  <div className="auto-container">
    <div className="text-center">
            <h1>{cardData.keyword}</h1>
    </div>
  </div>
</section>

  


      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-8 ">
              <img src='/images/keyword/28.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#2AA248', // green color
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className=' leadd'>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>


              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>


              <div>

              </div>


            </div>

            <div className='col-12 col-md-4' >


              <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px dotted #2AA248',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#2AA248' }}>
                      <h4 className=" lead fw-semibold whitt">Phone Numbers</h4>
                      <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                      <div className=''>
                        <a href="tel:+91 9175577266" className="d-block  text-white">+91 9175577266</a>

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      <i className="bi bi-envelope fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#2AA248' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:woodlandescape01@gmail.com" className=" text-white d-block">
                          woodlandescape01@gmail.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">
                      <i className="bi bi-house-fill fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#2AA248' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className="whit text-white ">
                          <i> Woodland Escape Resort:<br />
                            Wadamba, Behind St. Peters School, Deolapar, Dist. Nagpur - <br />441401

                          </i>
                        </p>
                      </div>
                    </div>
                  </div>

                </div>
              </div>


              {/* {Images.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href="./"
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href="./" className='darkcolorr'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })} */}


              
{Images.map((e, index) => {
  return (
    <div className="box1" key={index}>
      <a
        href={`/${e.link}`}
        className="d-flex justify-content-around align-items-center"
      >
        <div className="b1">
          <img src={e.place} alt={e.text} />
        </div>
        <div className="b2 darkcolorr">
          {e.text}
        </div>
      </a>
    </div>
  );
})}



             <Gallery images={images} ></Gallery>
              <table className="table table-responsive custom-table my-4">
                <thead>
                  <tr>
                    {cardData?.tableHeaders?.map((header, index) => (
                      <th key={index} className="custom-th">{header}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {cardData?.tableData?.map((row, rowIndex) => (
                    <tr className="custom-row" key={rowIndex}>
                      {row?.map((cell, cellIndex) => (
                        <td key={cellIndex} className="custom-td">
                          {cell}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>


              <div>
                <h3 className='Colo'>FAQs {cardData.keyword} for Woodland Escape Resort</h3>
                <Accordion data={faqData} />
              </div>
              <div className='py-3'>
                <CustomCarousel items={carouselItems} options={carouselOptions} />
              </div>


              {/* <div className="contact-box Borderr mt-5">
                <h3>{contactData.heading}</h3>
                <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                <div className="contact-details">
                  <p><strong className='darkcolor'>Mobile No:</strong></p>
                  <ul>
                    {contactData.contactNumbers.map((number, index) => (
                      <li key={index}>
                        <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                          {number}
                        </a>
                      </li>
                    ))}
                  </ul>

                  <p><strong className='darkcolor'>Email Id: </strong>
                    <a href={`mailto:${contactData.email}`} className="contact-link">
                      {contactData.email}
                    </a>
                  </p>
                </div>
              </div> */}
<div className="contact-box woodland-theme mt-5">
  <h3 className="heading">{contactData.heading}</h3>
  <p className="subtext">
    For booking inquiries or any assistance, please feel free to contact us:
  </p>

  <div className="contact-details">
    <p className="label">📞 Mobile No:</p>
    <ul className="number-list">
      {contactData.contactNumbers.map((number, index) => (
        <li key={index}>
          <a href={`tel:${number}`} className="contact-link">
            {number}
          </a>
        </li>
      ))}
    </ul>

    <p className="label">📧 Email Id:</p>
    <a href={`mailto:${contactData.email}`} className="contact-link email-link">
      {contactData.email}
    </a>
  </div>
</div>



            </div>
            {/* <BusRatesTable /> */}
          </div>
        </div>
      </section>






    </div>
  );
}

export default Picninspotneargadchiroli;